import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import usePreviousPregnancies from './hooks/usePreviousPregnancies';

export const PreviousPregnancies = () => {
    const { chartConfig } = usePreviousPregnancies();

    return (
        <ChartContainer
            title={"Evolução dos Partos em Gestações Anteriores"}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={350}
        />
    );
};
